<app-auth-page-layout>
    <div class="bg-white flex h-screen-safe w-screen overflow-hidden">
        <div class="flex flex-col w-full lg:w-[476px] lg:shrink-0 h-full bg-white overflow-y-auto">
            <div class="bg-white px-8 pt-10 pb-8 shrink-0">
                <div class="h-[24px] relative shrink-0 w-[117.44px]">
                    <img src="/assets/images/logo.svg" width="360px" height="auto" alt="gomaterials logo" />
                </div>
            </div>

            <div class="flex flex-col flex-1 px-10 pt-6">
                <div class="flex flex-col gap-[7px] mb-6">
                    <p class="text-(--text-color) text-[17.5px] font-semibold leading-normal">Welcome back!</p>
                    <p class="text-(--text-color) font-normal leading-relaxed">
                        Enter your email and password to login
                    </p>
                </div>

                <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="flex flex-col gap-6">
                    <div class="flex flex-col gap-[7px]">
                        <label class="text-(--text-color) font-normal leading-[21px]" [htmlFor]="'sign-in-email'">
                            Email
                        </label>
                        <div>
                            <go-input-email
                                [fluid]="true"
                                inputId="sign-in-email"
                                placeholder="your@companyname.com"
                                required
                                [showRightIcon]="true"
                                formControlName="email"
                                [invalid]="isInvalid('email')"
                                data-test-id="sign-in-email-field"
                            >
                                <ng-template #rightIcon>
                                    <fa-icon class="text-(--iconfield-icon-color)" [icon]="faEnvelope"></fa-icon>
                                </ng-template>
                            </go-input-email>
                            @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
                                <small class="p-formfield-error">Email is empty</small>
                            } @else if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
                                <small class="p-formfield-error">Invalid email</small>
                            }
                        </div>
                    </div>
                    <div class="flex flex-col gap-[7px]">
                        <label class="text-(--text-color) font-normal leading-[21px]" [htmlFor]="'sign-in-password'">
                            Password
                        </label>
                        <div>
                            <go-password
                                [fluid]="true"
                                inputId="sign-in-password"
                                placeholder="Enter your password"
                                [toggleMask]="true"
                                autocomplete="off"
                                [feedback]="false"
                                required
                                [minlength]="6"
                                formControlName="password"
                                [invalid]="isInvalid('password')"
                                data-test-id="sign-in-password-field"
                            />
                            @if (form.get('password')?.touched && form.get('password')?.hasError('required')) {
                                <small class="p-formfield-error">Password is empty</small>
                            } @else if (form.get('password')?.touched && form.get('password')?.hasError('minlength')) {
                                <small class="p-formfield-error">Invalid password</small>
                            }
                        </div>
                    </div>

                    <go-button
                        type="submit"
                        [fluid]="true"
                        severity="primary"
                        [rounded]="true"
                        size="large"
                        label="Login"
                        [disabled]="loading()"
                        [loading]="loading()"
                        data-test-id="login-button"
                    ></go-button>
                </form>

                <div class="flex-1"></div>

                <div class="pb-10 text-center pt-10">
                    <p class="text-(--text-color) font-normal leading-relaxed">Version 2.4.0-SNAPSHOT</p>
                </div>
            </div>
        </div>
        <div
            class="flex-1 relative overflow-hidden bg-[#e8ebe0] hidden md:block bg-[url('/assets/images/map.png')] bg-cover bg-center bg-no-repeat"
        ></div>
    </div>
</app-auth-page-layout>
